import { useState } from "react";
import { caseItems, caseCategories, type CaseItem } from "@/mocks/lawfirm";
import CaseCard from "@/components/feature/CaseCard";
import CaseModal from "@/components/feature/CaseModal";

const filters = ["전체", ...caseCategories];

export default function Cases() {
  const [active, setActive] = useState("전체");
  const [selected, setSelected] = useState<CaseItem | null>(null);
  const filtered = active === "전체" ? caseItems : caseItems.filter((c) => c.category === active);
  const list = filtered.slice(0, 6);

  return (
    <section id="cases" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <p className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
            <i className="ri-trophy-line"></i>
            WINNING CASES
          </p>
          <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
            재판의 흐름을 아는 변호사의 <span className="text-accent-600">성공사례</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600">
            광주부장판사·검사출신변호사로서 쌓아온 신뢰의 결과물입니다.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`rounded-full px-5 py-2 text-xs md:text-sm font-medium transition-colors whitespace-nowrap ${
                active === f
                  ? "bg-primary-500 text-white"
                  : "bg-white text-foreground-700 border border-background-200 hover:border-primary-300"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {list.map((c) => (
            <CaseCard key={c.id} item={c} onClick={setSelected} hideThumbnailOnMobile clampDescOnMobile />
          ))}
        </div>

        <p className="mt-8 text-center text-xs text-foreground-400">
          ※ 사례는 의뢰인 정보 보호를 위해 요약된 내용이며, 사건의 특성에 따라 결과가 달라질 수 있습니다.
        </p>
      </div>

      <CaseModal item={selected} onClose={() => setSelected(null)} />
    </section>
  );
}